var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransfer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 56,
    viewBox: "0 0 64 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_324",
    "data-name": "Union 324",
    d: "M-243,2541a3.338,3.338,0,0,1-3.333-3.333v-12h-6a2,2,0,0,1-1.848-1.235,2,2,0,0,1,.435-2.178l12.666-12.667a2,2,0,0,1,2.83,0l12.667,12.667a2,2,0,0,1,.435,2.178,2,2,0,0,1-1.849,1.235h-6v12a3.338,3.338,0,0,1-3.334,3.333Zm-4.5-19.333h3.171a2,2,0,0,1,2,2V2537H-237v-13.333a2,2,0,0,1,2-2h3.171l-7.837-7.837ZM-281.667,2533a7.339,7.339,0,0,1-7.333-7.333v-33.333a7.339,7.339,0,0,1,7.333-7.333h49.332a7.339,7.339,0,0,1,7.332,7.333v17.333h-4v-17.333a3.338,3.338,0,0,0-3.333-3.334h-49.332a3.339,3.339,0,0,0-3.334,3.334v6h15.333a7.339,7.339,0,0,1,7.332,7.333v6.666a7.339,7.339,0,0,1-7.332,7.333H-285v6a3.338,3.338,0,0,0,3.334,3.333H-259v4ZM-285,2515.667h15.333a3.338,3.338,0,0,0,3.333-3.333v-6.666a3.338,3.338,0,0,0-3.333-3.334H-285Zm6.666-6.667a2.667,2.667,0,0,1,2.667-2.667A2.667,2.667,0,0,1-273,2509a2.667,2.667,0,0,1-2.667,2.667A2.667,2.667,0,0,1-278.334,2509Z",
    transform: "translate(289 -2485)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.007bdb8ac14e09c5f560e51b2cda8536.svg";
export { ForwardRef as ReactComponent };